<template>
	<component
		:is="loader"
		v-if="loader"
		:data="data"
		:options="options"
		:additional="additional"
	></component>
</template>

<script>
export default {
	name: 'DynamicWidget',
	props: {
		additional: {
			type: Object,
			default: () => {
				return {}
			}
		},
		type: {
			type: String,
			default: null
		},
		data: {
			type: Array,
			default: () => {
				return {}
			}
		},
		options: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			component: null
		}
	},
	computed: {
		loader() {
			if (!this.type) {
				return null
			}
			return this.type
		}
	}
}
</script>
